module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-welcome"
  }, [_c('TitleTrigger', {
    staticClass: "custom-home-welcome__title-trigger",
    attrs: {
      "props": 1
    }
  }), _c('div', {
    staticClass: "custom-home-welcome__container"
  }, [_c('div', {
    staticClass: "custom-home-welcome__row"
  }, [_c('div', {
    staticClass: "custom-home-welcome__col-left"
  }, [_c('div', {
    staticClass: "custom-home-welcome__title",
    class: {
      active: this.titleActive
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-home-welcome__tagline",
    domProps: {
      "innerHTML": _vm._s(_vm.props.tagline)
    }
  }), _c('div', {
    staticClass: "custom-home-welcome__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content)
    }
  }), _c('router-link', {
    staticClass: "custom-home-welcome__link-text",
    attrs: {
      "to": _vm.props.link_page
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.link_text)
    }
  })], 1), _c('div', {
    staticClass: "custom-home-welcome__col-right"
  }, [_c('SliderHome', {
    attrs: {
      "props": _vm.props.slides
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c6c6895","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-welcome/custom-home-welcome.pug
// module id = 622
// module chunks = 1